import { useQuery } from "@tanstack/react-query";
import { mathosApi } from "../api";

export const familySessionKey = ["family-session"] as const;

export function useFamilySession() {
  return useQuery({
    queryKey: familySessionKey,
    queryFn: () => mathosApi.getSession(),
  });
}
